import { useMutation, useQueryClient } from '@tanstack/react-query';

import useAPI from '@/hooks/useAPI';
import FormLibraryRepository from '@/repositories/FormLibraryRepository';

export const useLibraryQuestions = (search: string, enabled = true) => {
  const repo = FormLibraryRepository();

  return useAPI({
    enabled,
    queryKey: ['libraryQuestions', search],
    queryFn: async () => {
      const response = await repo.listQuestions(search || undefined);
      if (response.isError) throw new Error(response.errorMessage ?? 'Failed to load');
      return response.data;
    }
  });
};

export const useLibrarySections = (search: string, enabled = true) => {
  const repo = FormLibraryRepository();

  return useAPI({
    enabled,
    queryKey: ['librarySections', search],
    queryFn: async () => {
      const response = await repo.listSections(search || undefined);
      if (response.isError) throw new Error(response.errorMessage ?? 'Failed to load');
      return response.data;
    }
  });
};

export const useDeleteLibraryQuestion = () => {
  const repo = FormLibraryRepository();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (questionId: string) => {
      const response = await repo.deleteQuestion(questionId);
      if (response.isError) throw new Error(response.errorMessage ?? 'Failed to remove question');
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['libraryQuestions'] });
    }
  });
};
